export {
  default as getCommonUserContext,
  getContextForCurrentPlatform,
  getContextForPlatform,
} from './src/commonContext';
